module.exports = __webpack_public_path__ + "img/logo-long.0198deb3.png";